// extracted by mini-css-extract-plugin
export default {"add-dapp":"AddDapp_add-dapp__Fq5mq","table-mobile-container":"AddDapp_table-mobile-container__qIElV"};